import Ajv from "ajv";
import * as Sentry from "@sentry/vue";

export const updateContentFormat = (content) => {
  let formattedContent = "";
  formattedContent = content
    // add Superscript
    .replaceAll("^!", "<sup>")
    .replaceAll("!^", "</sup>")
    // add SubScript
    .replaceAll("|!", "<sub>")
    .replaceAll("!|", "</sub>")
    // add an image
    .replaceAll("![", "<img ")
    .replaceAll("]!", ">");

  return formattedContent;
};

export const validateJsonSchema = (schema, jsonData) => {
  const ajv = new Ajv();

  const validate = ajv.compile(schema);
  const validationResult = validate(jsonData);
  if (!validationResult)
    Sentry.captureException(new Error("error validating json"), {
      extra: { error: validate.errors },
    });

  return validationResult;
};
